// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAndShippingStyles } from "@bg/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

billingAndShippingStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
    `,
};

billingAndShippingStyles.titleGridItem = {
    css: css`
        width: 100%;
    `,
};

billingAndShippingStyles.title = {
    variant: "h2",
};

billingAndShippingStyles.addressContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: space-between;
        gap: 24px 60px;
        width: 100%;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

billingAndShippingStyles.shipToTitleText = {
    variant: "h5",
};

billingAndShippingStyles.pickUpTitleText = {
    variant: "h5",
};

billingAndShippingStyles.billToTitleText = {
    variant: "h5",
};
